import * as React from 'react'
import { observer } from 'mobx-react'
import CallViewModel from 'messaging/calling/CallViewModel'
import Icon from 'components/Icon'
import { addSeparators } from 'utils/array-util'
import styles from './StatusBar.sass'

interface StatusBarProps {
  vm: CallViewModel
}

/**
 * The StatusBar
 */
export default observer(function StatusBar({ vm }: StatusBarProps) {
  const muted = vm.participants
    .filter((p) => p !== vm.currentUserParticipant && p.media?.muted)
    .map((p) => p.participant.member.givenName)
  return (
    <div className={styles.root}>
      {muted.length > 0 && (
        <div className={styles.mutedInfo}>
          <div className={styles.mutedIcon}>
            <Icon name="call-mic-off" />
          </div>
          <div className={styles.mutedText}>
            {addSeparators(muted, (_, __, resultingIndex, newLength) =>
              resultingIndex === newLength - 1 ? ' and ' : ', '
            )}
            {muted.length === 1 ? ' is muted' : ' are muted'}
          </div>
        </div>
      )}
    </div>
  )
})
